import { Controller } from "@hotwired/stimulus"
import type { TurboSubmitEndEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import SelectionToolbarController from "../selection_toolbar_controller"

export default class AddClientsController extends Controller {
  declare formTarget: HTMLFormElement
  declare toolbarTarget: HTMLElement
  declare submitButtonTarget: HTMLButtonElement
  declare hasSubmitButtonTarget: boolean

  static targets = ["form", "toolbar", "submitButton"]

  connect() {
    this.updateSubmitButton()
  }

  handleSubmitStart(event: TurboSubmitStartEvent) {
    const toolbarController = SelectionToolbarController.getInstance(this.toolbarTarget)
    const ids = toolbarController?.selectedIds() || []
    ids.forEach(id => {
      event.detail.formSubmission.fetchRequest.body.append("client_ids[]", id)
    })
  }

  handleSubmitEnd(event: TurboSubmitEndEvent) {
    if (event.detail.success) {
      const modalEl = this.element.closest(".modal")
      if (modalEl) {
        const modal = globalThis.bootstrap.Modal.getInstance(modalEl)
        modal?.hide()
      }
    }
  }

  handleHidden() {
    const toolbarController = SelectionToolbarController.getInstance(this.toolbarTarget)
    toolbarController?.clearSelected()
    this.updateSubmitButton()
  }

  handleSelectionChange() {
    this.updateSubmitButton()
  }

  private updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return

    const toolbarController = SelectionToolbarController.getInstance(this.toolbarTarget)
    const selectedCount = toolbarController?.selectedIds().length || 0
    this.submitButtonTarget.disabled = selectedCount === 0
  }
}
